import { Action, reducerFn, ReducerState } from "../../helpers/reducers";
import { Map, fromJS } from "immutable";
import {
    SETTINGS_TOGGLE_EDITOR_THEME,
    SETTINGS_DOC_LAST_OPENED,
    SETTINGS_REMOVE_DOC_LAST_OPENED,
} from "./actions";

interface Settings {
    doc_id?: string;
    page_id?: string;
    enableDarkTheme: boolean;
    docLastOpened: ReturnType<typeof Map> | Array<Record<number, number>>;
}

const initialState: Settings = {
    enableDarkTheme: false,
    docLastOpened: Map({}),
};

type SettingsAction = Action<Settings>;

const fnMap = {
    [SETTINGS_TOGGLE_EDITOR_THEME]: (s: ReducerState, _a: SettingsAction) =>
        s.set("enableDarkTheme", !s.get("enableDarkTheme")),

    [SETTINGS_DOC_LAST_OPENED]: (
        s: ReducerState,
        { payload: { doc_id, page_id } }: SettingsAction
    ) => s.setIn(["docLastOpened", doc_id], page_id),

    [SETTINGS_REMOVE_DOC_LAST_OPENED]: (
        s: ReducerState,
        { payload: { doc_id } }: SettingsAction
    ) => s.removeIn(["docLastOpened", doc_id]),
};

function transformRehydrate(saved: Settings) {
    let next = fromJS(initialState);
    //@ts-ignore
    next = next.set("enableDarkTheme", saved.enableDarkTheme || false);

    if (Object.keys(saved.docLastOpened).length > 0) {
        const opened: Record<number, number> = {};
        for (const [k, v] of Object.entries(saved.docLastOpened)) {
            opened[parseInt(k)] = parseInt(v);
        }
        //@ts-ignore
        next = next.set("docLastOpened", fromJS(opened));
    }

    return next;
}

export const settingsReducer = reducerFn("settings", initialState, fnMap, {
    transformRehydrate,
});
